<script setup lang="ts">
import CommunityPartnerAd from "~/components/common/CommunityPartnerAd.vue";

const props = defineProps<{
  slots?: number
  title?: string
}>()

const runtimeConfig = useRuntimeConfig()
const wadPlatformBaseUrl = runtimeConfig.public.wadPlatformBaseUrl
const wadApiBaseUrl = runtimeConfig.public.wadApiBaseUrl
const partnerAds = ref([])
const loading = ref(true)
const slots = props.slots ?? 4

onMounted(async () => {
  try {
    const res = await fetch(`${wadApiBaseUrl}/v2/ads/community-partners?ads_count=${slots}`)
    const data = await res.json()
    partnerAds.value = data.data
  } finally {
    loading.value = false
  }
})
</script>

<template>
  <div class="wad4-ads wad4__container--columns">
    <client-only>
      <template v-if="loading">
        <div v-for="n in slots" :key="n" class="wad4-ads-skeleton"></div>
      </template>
      <template v-else>
        <CommunityPartnerAd v-for="ad in partnerAds" :key="ad.entity_id" :ad="ad" :base-url="wadPlatformBaseUrl"/>
      </template>
    </client-only>
  </div>
</template>

<style lang="scss">
.wad4-ads-skeleton {
  height: 130px;
  border-radius: 8px;
  background: linear-gradient(100deg, $wad4-bc-neutral-50 30%, $wad4-bc-neutral-100 50%, $wad4-bc-neutral-50 70%);
  background-size: 200% 100%;
  animation: shimmer 3s ease-in-out infinite;
  width: $wad4-col-3;
  @include mqBreakPoint(0, $wad4-breakpoint-desktop-max) {
    width: $wad4-col-6;
  }
  @include mqBreakPoint(0, $wad4-breakpoint-tablet-max) {
    width: $wad4-col-4;
  }
}

@keyframes shimmer {
  0% {
    background-position: 200% 0;
  }
  100% {
    background-position: -200% 0;
  }
}
</style>
